// Parse safe amount into a floating point number.
export function parseAmount(value: string): number {
  if (value.length === 0) {
    return NaN;
  }

  const numeric = parseFloat(value.replace(/^\./, '0.'));
  if (isNaN(numeric)) {
    return NaN;
  }

  const rounded = roundAmount(numeric);

  return (rounded > 0) ? rounded : NaN;
}

// Round amount to make it have a maximum of 2 numbers after point.
export function roundAmount(value: number): number {
  return Math.round(value * 100) / 100;
}
